"use client";
import { Close as e } from "../Icon/icons.gen.mjs";
import { VisuallyHidden as t } from "../VisuallyHidden/VisuallyHidden.mjs";
import "../../../utils/iconDefaults.mjs";
import { appendToChildren as n } from "../../../utils/appendToChildren.mjs";
import { forwardRef as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import * as o from "@radix-ui/react-popover";
//#region src/components/atoms/Popover/Popover.tsx
var s = (e) => /* @__PURE__ */ i(o.Root, {
	"data-slot": "popover",
	...e
}), c = r((e, t) => /* @__PURE__ */ i(o.Trigger, {
	"data-slot": "popover-trigger",
	...e,
	ref: t
}));
c.displayName = "PopoverTrigger";
var l = r((e, t) => /* @__PURE__ */ i(o.Anchor, {
	"data-slot": "popover-anchor",
	...e,
	ref: t
}));
l.displayName = "PopoverAnchor";
var u = (e) => /* @__PURE__ */ i(o.Portal, {
	"data-slot": "popover-portal",
	...e
}), d = r((e, t) => /* @__PURE__ */ i(o.Close, {
	"data-slot": "popover-close",
	...e,
	ref: t
}));
d.displayName = "PopoverClose";
var f = r((e, t) => /* @__PURE__ */ i(o.Arrow, {
	"data-slot": "popover-arrow",
	...e,
	ref: t
}));
f.displayName = "PopoverArrow";
var p = r(({ children: r, showCloseButton: s = !1, closeLabel: c = "Close", asChild: l, ...f }, p) => /* @__PURE__ */ i(u, { children: /* @__PURE__ */ i(o.Content, {
	"data-slot": "popover-content",
	asChild: l,
	...f,
	ref: p,
	children: n(r, s && /* @__PURE__ */ a(d, { children: [/* @__PURE__ */ i(e, {
		"data-slot": "popover-close-icon",
		"aria-hidden": "true",
		className: "size-4 shrink-0 [&_path]:fill-current"
	}), /* @__PURE__ */ i(t, { children: c })] }), l)
}) }));
p.displayName = "PopoverContent";
//#endregion
export { l as PopoverAnchor, f as PopoverArrow, d as PopoverClose, p as PopoverContent, u as PopoverPortal, s as PopoverRoot, c as PopoverTrigger };
